<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>维护资产套装</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-form :model="suit" ref="suitInfo">
            <div class="content-caption dashed">
                <span>基本信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">套装名称</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="name" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-input type="text" v-model="suit.name" style="width:262px;" placeholder="请输入套装名称"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">所属机构</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="retailerShopName" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-input class="bottom-line width-1-5x" v-model="suit.retailerShopName" placeholder="请选择所属机构" :disabled="true"></el-input>
                            <i v-if="suit.id == null" class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="showOrgSelectDlg()"></i>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>主资产信息</span>
                <a class="swb-btn swb-btn-link" @click="showMainDeviceSelectDlg">选择主资产</a>
            </div>
            <div class="simple-form">
                <div class="form-group center" v-if="suit.imageUrl != null && suit.imageUrl != ''">
                    <div class="form-label">
                        <label>资产图片</label>
                    </div>
                    <div class="form-value">
                        <img :src="suit.imageUrl" style="width: 100px;">
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">资产描述全称</label>
                    </div>
                    <div class="form-value width-2x">
                        <div class="pos-rel" style="width: 262px">
                            <el-input class="bottom-line width-1-5x" v-model="suit.devcTitle" placeholder="请选择主资产" :disabled="true"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">系统编号</label>
                    </div>
                    <div class="form-value width-2x">
                        <div class="pos-rel" style="width: 262px">
                            <el-input class="bottom-line width-1-5x" v-model="suit.devcTmpNo" placeholder="请选择主资产" :disabled="true"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">分类</label>
                    </div>
                    <div class="form-value width-2x">
                        <div class="pos-rel" style="width: 262px">
                            <el-input class="bottom-line width-1-5x" v-model="suit.devcCatName" placeholder="请选择主资产" :disabled="true"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">品牌</label>
                    </div>
                    <div class="form-value width-2x">
                        <div class="pos-rel" style="width: 262px">
                            <el-input class="bottom-line width-1-5x" v-model="suit.devcBrandName" placeholder="请选择主资产" :disabled="true"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">规格</label>
                    </div>
                    <div class="form-value width-2x">
                        <div class="pos-rel" style="width: 262px">
                            <el-input class="bottom-line width-1-5x" v-model="suit.devcModelSpec" placeholder="请选择主资产" :disabled="true"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>责任部门</label>
                    </div>
                    <div class="form-value width-2x">
                        <div class="pos-rel" style="width: 262px">
                            <el-input class="bottom-line width-1-5x" v-model="suit.departName" :disabled="true"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>责任人</label>
                    </div>
                    <div class="form-value width-2x">
                        <div class="pos-rel" style="width: 262px">
                            <el-input class="bottom-line width-1-5x" v-model="suit.principalName" :disabled="true"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>备注</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-input style="height: 78px; width: 420px;" type="textarea" v-model="suit.memo"></el-input>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="content-caption dashed">
            <span>附属资产信息</span>
            <a class="swb-btn swb-btn-mini" @click="showOtherDeviceSelectDlg">选择附属资产</a>
        </div>
        <div class="table-layout">
            <el-table :data="suit.shopDeviceSuitAccList" border style="width: 100%">
                <el-table-column align="left" width="100" label="图片">
                    <template slot-scope="rows">
                        <img :src="rows.row.imageUrl" v-if="rows.row.imageUrl != null && rows.row.imageUrl!=''">
                    </template>
                </el-table-column>
                <el-table-column prop="devcTitle" label="名称" align="left" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="devcTmpNo" label="系统编号" width="250" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="devcCatName" label="分类" width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="devcBrandName" label="品牌" width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="devcModelSpec" label="规格" width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="departName" label="责任部门" width="100" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="principalName" label="责任人" width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="memo" label="备注">
                    <template slot-scope="rows">
                        <el-input v-model="rows.row.memo" placeholder="请输入备注"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="80" label="操作" show-overflow-tooltip fixed="right">
                    <template slot-scope="scope">
                        <a class="swb-btn-link" @click="removeItem(scope.$index)">移除</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary" @click="prevStock">返回</button>
            <button class="swb-btn swb-btn-small" @click="saveSuit">保存</button>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { getDefaultPageSizes } from '../../../src/app.conf'
    import { showAssetSelectDlg } from './selectDlg';
    import { syncSetBreadcrumb } from '../index'
    import { showDevcSelectDlg } from '../devc/selectDlg'

    import devcApi from '../../api/devc'

    import SwbShopDeviceSuitList from './ShopDeviceSuitList';
    Vue.regist(SwbShopDeviceSuitList);

    export default {
        name: 'swb-shop-device-suit-save',
        path: '/shop/device/suit/save',
        desc: '资产套装维护',
        customBreadcrumb: true,
        notAsResc: true,
        authen: false,
        data: function () {
            return {
                suit: {
                    id: null,
                    name: null,
                    retailerShopId: null,
                    retailerShopLevel: null,
                    retailerShopName: null,
                    retailerShopId1: null,
                    retailerShopId2: null,
                    retailerShopId3: null,
                    retailerShopId4: null,
                    devcTmpNo: null,
                    devcCatName: null,
                    devcBrandName: null,
                    devcTitle: null,
                    devcModelSpec: null,
                    departName: null,
                    principalName: null,
                    memo: null,
                    shopDeviceSuitAccList: [],
                    imageUrl: null
                }
            }
        },
        created: function () {
            syncSetBreadcrumb("资产套装维护", SwbShopDeviceSuitList.path);
            let id = this.$route.query.id || null;
            if(!Utils.isNoB(id)) {
                this.suit.id = id;
                this.getSuitById();
            }
        },
        methods: {
            getSuitById(){
                let self = this;
                let theLoading = MsgBox.loading();
                devcApi.getShopDeviceSuitById(this.suit.id, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        self.suit = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            checkNull: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            prevStock: function () {
                let self = this;
                self.$router.back(-1);
            },
            saveSuit(){
                let self = this;
                let suit = self.suit;
                this.$refs['suitInfo'].validate(function (valid) {
                    if(valid) {
                        if(Utils.isNoB(suit.devcTmpNo)) {
                            Toast.show("请选择主资产");
                            return;
                        }
                        if(!Utils.isNoB(suit.memo)) {
                            if(suit.memo.length > 250) {
                                Toast.show("备注不能超过200个字");
                                return;
                            }
                        }
                        if(Utils.isNoB(suit.id)) {
                            let theLoading = MsgBox.loading();
                            devcApi.saveShopDeviceSuit(suit, function (result) {
                                theLoading.close();
                                if(result.type == 'info') {
                                    MsgBox.success("资产套装保存成功");
                                    self.$router.push({
                                        path: SwbShopDeviceSuitList.path
                                    });
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        } else {
                            // 修改
                            let theLoading = MsgBox.loading();
                            devcApi.updateShopDeviceSuit(suit, function (result) {
                                theLoading.close();
                                if(result.type == 'info') {
                                    MsgBox.success("资产套装保存成功");
                                    self.$router.push({
                                        path: SwbShopDeviceSuitList.path
                                    });
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }
                    }
                });
            },
            showOrgSelectDlg(){
                let suit = this.suit;
                Vue.$showDialog({
                    title: '零售商机构-选择',
                    width: 750,
                    height: 700,
                    showCloseBtn: true,
                    template: '<swb-org-tree :isShowIcon="false" :isSelectThisLevel="isSelectThisLevel" :isRadio="isRadio" :isCom="isCom"  ref="swb_org_tree"></swb-org-tree>',
                    data: {
                        isRadio: true,
                        isCom: false,
                        isSelectThisLevel: true
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_org_tree.getDlgResult() || {};
                        if(result.type == "info") {
                            //
                            let shopRetail = result.data;
                            if(suit.retailerShopId != shopRetail.id) {
                                suit.retailerShopId = shopRetail.id;
                                suit.retailerShopLevel = shopRetail.level;
                                suit.retailerShopName = shopRetail.name;
                                suit.retailerShopId1 = shopRetail.comId1;
                                suit.retailerShopId2 = shopRetail.comId2;
                                suit.retailerShopId3 = shopRetail.comId3;
                                suit.retailerShopId4 = shopRetail.comId4;
                                //
                                suit.devcTmpNo = null;
                                suit.devcCatName = null;
                                suit.devcBrandName = null;
                                suit.devcTitle = null;
                                suit.devcModelSpec = null;
                                suit.departName = null;
                                suit.principalName = null;
                                suit.shopDeviceSuitAccList = [];
                            }
                        } else {
                            return false;
                        }
                    }
                });
            },
            showMainDeviceSelectDlg() {
                let self = this;
                let suit = this.suit;
                let shopDeviceSuitAccList = suit.shopDeviceSuitAccList;
                if(Utils.isNoB(suit.retailerShopId)) {
                    Toast.show("请选择所属机构");
                    return;
                }
                let selectIds = shopDeviceSuitAccList.pluck('devcId');
                if(!Utils.isNoB(suit.devcId)) {
                    selectIds.push(suit.devcId);
                }
                let params = {
                    filter: {
                        retailerComId: suit.retailerShopId,
                        querySuitIsNull: true,
                        assetType: 0
                    },
                    initSelectIds: selectIds,
                    checkBox: false,
                    devcBizClolumType: 'TaoZhuangDlg'
                };
                showDevcSelectDlg(params, function (device) {
                    let errMsg = null;
                    if(shopDeviceSuitAccList != null && shopDeviceSuitAccList.length > 0) {
                        shopDeviceSuitAccList.forEach(function (acc) {
                            if(acc.devcTmpNo == device.tmpNo) {
                                errMsg = "附属资产不能包含主资产:【" + device.title + "】【" + device.tmpNo + "】";
                            }
                        });
                    }
                    if(errMsg == null) {
                        suit.devcId = device.id;
                        suit.devcTmpNo = device.tmpNo;
                        suit.devcCatName = device.catName;
                        suit.devcBrandName = device.brandName;
                        suit.devcTitle = device.title;
                        suit.devcModelSpec = device.modelSpec;
                        suit.imageUrl = device.imageUrl;
                        suit.departName = device.respblDepartFullName;
                        suit.principalName = device.respblStaffName;
                    } else {
                        MsgBox.warning(errMsg);
                    }
                });
            },
            showOtherDeviceSelectDlg(){
                let self = this;
                let suit = this.suit;
                let shopDeviceSuitAccList = suit.shopDeviceSuitAccList;
                if(Utils.isNoB(suit.retailerShopId)) {
                    Toast.show("请选择所属机构");
                    return;
                }
                let selectIds = shopDeviceSuitAccList.pluck('devcId');
                if(!Utils.isNoB(suit.devcId)) {
                    selectIds.push(suit.devcId);
                }
                let params = {
                    filter: {
                        retailerComId: suit.retailerShopId,
                        querySuitIsNull: true,
                        assetType: 0
                    },
                    initSelectIds: selectIds,
                    devcBizClolumType: 'TaoZhuangDlg'
                };
                showDevcSelectDlg(params, function (devices) {
                    devices.forEach(function (device) {
                        let isAdd = true;
                        shopDeviceSuitAccList.forEach(function (acc) {
                            if(acc.devcTmpNo == device.tmpNo) {
                                isAdd = false;
                            }
                        });
                        if(isAdd) {
                            let shopDeviceSuitAcc = {
                                devcId: device.id,
                                devcTmpNo: device.tmpNo,
                                devcCatName: device.catName,
                                devcBrandName: device.brandName,
                                devcTitle: device.title,
                                devcModelSpec: device.modelSpec,
                                memo: null,
                                imageUrl: device.imageUrl,
                                departName: device.respblDepartFullName,
                                principalName: device.respblStaffName
                            };
                            if(suit.devcTmpNo != null && suit.devcTmpNo == shopDeviceSuitAcc.devcTmpNo) {
                                MsgBox.warning("附属资产不能包含主资产:【" + device.title + "】【" + device.tmpNo + "】");
                            } else {
                                shopDeviceSuitAccList.push(shopDeviceSuitAcc);
                            }
                        }
                    });
                    suit.shopDeviceSuitAccList = Utils.merge([], shopDeviceSuitAccList);
                });
            },
            removeItem: function (index) {
                let self = this;
                let shopDeviceSuitAccList = self.suit.shopDeviceSuitAccList;
                for(let i = 0; i < shopDeviceSuitAccList.length; i++) {
                    if(i == index) {
                        shopDeviceSuitAccList.remove(shopDeviceSuitAccList[i]);
                    }
                }
                self.suit.shopDeviceSuitAccList = Utils.merge([], shopDeviceSuitAccList);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceSuitSave.vue